:host {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  block-size: 0; // Not loading by default
  inline-size: 100%;
  pointer-events: none;
}

// "Hide" the infinite scroll, but with the possibility to check its position
// in the parent's scroll
:host(.loading) {
  block-size: auto;
}
